module.exports = __webpack_public_path__ + "media/julio_network_button.57a0a19f.mp4";